import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { ICall } from '@/models';

import { http } from './http';
import { IGetParams, IListResponse, IPaginatedListResponse } from './types';

export type EndCall = {
  disposition: string;
  notes: string;
};

// Account-global flag: true when any call carries an extension (OKG only).
export type IncomingCallsListResponse = IPaginatedListResponse<ICall> & {
  hasExtension: boolean;
};

export const IncomingCallsApi = {
  getCalls: async (
    params?: IGetParams,
  ): Promise<AxiosResponse<IncomingCallsListResponse>> => {
    return http.get(`api/${ApiVersion.V1}/incoming-calls`, {
      params,
    });
  },
  updateCallReadStatus: async (
    _id: string,
  ): Promise<AxiosResponse<IListResponse<ICall>>> => {
    return http.patch(`api/${ApiVersion.V1}/incoming-calls/${_id}/read`);
  },
  endCall: async (
    _id: string,
    endCall: EndCall,
  ): Promise<AxiosResponse<IListResponse<ICall>>> => {
    return http.patch(`api/${ApiVersion.V1}/incoming-calls/${_id}/update`, {
      ...endCall,
    });
  },
  updateCallNotes: async (
    _id: string,
    notes: string,
  ): Promise<AxiosResponse<IListResponse<ICall>>> => {
    return http.patch(`api/${ApiVersion.V1}/incoming-calls/${_id}/notes`, {
      notes,
    });
  },
};
